export default __webpack_public_path__ + "static/media/Add.988471ac.svg";